import { Injectable, inject } from '@angular/core';

import { CoreActions } from '@next/core-lib';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { finalize, map, mergeMap, startWith } from 'rxjs/operators';

import { DeliveryLine, FeedState } from '../../models/feed.model';
import { FeedService } from '../../services/feed.service';
import * as FeedActions from '../actions/feed.actions';

@Injectable()
export class FeedEffects {
  private readonly actions$ = inject(Actions);
  private readonly feedService = inject(FeedService);
  private readonly store = inject<Store<FeedState>>(Store);

  protected getDeliveries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeedActions.loadDeliveryLines),
      mergeMap((values) =>
        this.feedService.get(values.dateFrom, values.dateTo).pipe(
          map((deliveryLines: DeliveryLine[]) =>
            FeedActions.loadDeliveryLinesSuccess({ deliveryLines }),
          ),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
